<template>
  <div class="action-dropdown" :class="{ open: isOpen }">
    <button type="button" class="action-trigger" @click.stop.prevent="toggleDropdown">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </button>
    <div class="dropdown-menu" :style="menuStyle">
      <button type="button" class="dropdown-item" @click.stop.prevent="handleEdit">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Edit User
      </button>
      <button type="button" class="dropdown-item" @click.stop.prevent="handleDeactivate">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="3"
            y="11"
            width="18"
            height="11"
            rx="2"
            ry="2"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {{ isUserActive ? "Deactivate User" : "Activate User" }}
      </button>
      <button type="button" class="dropdown-item delete" @click.stop.prevent="handleDelete">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 6H5H21"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Delete User
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActionDropdown",
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      menuStyle: {},
    };
  },
  computed: {
    isUserActive() {
      return this.user.is_active !== false;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
  methods: {
    handleDocumentClick(e) {
      // Close dropdown if click is outside this component
      if (this.isOpen && this.$el && !this.$el.contains(e.target)) {
        this.isOpen = false;
      }
    },
    toggleDropdown() {
      if (!this.isOpen) {
        this.calculatePosition();
      }
      this.isOpen = !this.isOpen;
    },
    calculatePosition() {
      this.$nextTick(() => {
        const trigger = this.$el.querySelector(".action-trigger");
        if (!trigger) return;

        const rect = trigger.getBoundingClientRect();
        const menuHeight = 150; // Approximate menu height
        const menuWidth = 170;
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;

        let top = rect.bottom + 4;
        let left = rect.right - menuWidth;

        // If menu would go below viewport, show it above the trigger
        if (top + menuHeight > viewportHeight) {
          top = rect.top - menuHeight - 4;
        }

        // If menu would go off the left edge, align to left of trigger
        if (left < 8) {
          left = rect.left;
        }

        // If menu would go off the right edge
        if (left + menuWidth > viewportWidth - 8) {
          left = viewportWidth - menuWidth - 8;
        }

        this.menuStyle = {
          top: `${top}px`,
          left: `${left}px`,
        };
      });
    },
    handleEdit() {
      this.$emit("edit", this.user);
      this.isOpen = false;
    },
    handleDeactivate() {
      this.$emit("deactivate", this.user);
      this.isOpen = false;
    },
    handleDelete() {
      this.$emit("delete", this.user);
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.action-dropdown {
  position: relative;
  display: inline-block;

  .dropdown-menu {
    display: none;
  }

  &.open .dropdown-menu {
    display: block;
  }
}

.action-trigger {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #f3f4f6;
  }

  .dot {
    width: 4px;
    height: 4px;
    background: #6b7280;
    border-radius: 50%;
    pointer-events: none;
  }
}

.dropdown-menu {
  position: fixed;
  z-index: 1000;
  min-width: 170px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 16px;
  background: none;
  border: none;
  text-align: left;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #f9fafb;
  }

  &.delete {
    color: #dc2626;

    svg {
      color: #dc2626;
    }
  }

  svg {
    flex-shrink: 0;
    color: #6b7280;
  }
}
</style>
